import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/EmployersTable/component'

export const EmployersTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
